<template>
  <v-card class=" pa-10" flat>
    <div>
      <v-card-title class="pa-0">
        清空會員Email驗證次數
      </v-card-title>
      <div class="d-flex align-center">
        <v-text-field v-model="member_email" label="Email" @keydown.enter="resetMemberVerifyCount"></v-text-field>
        <v-btn dark class="indigo mx-8" @click="resetMemberVerifyCount">清空</v-btn>
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      member_email: '',
    }
  },
  methods: {
    resetMemberVerifyCount() {
      this.axios.get(`/admin/verify/refresh?email=${this.member_email}`).then(response => {
        this.$root.$emit('alert', 'success', '清空驗證次數成功')
        this.member_email = ''
      }).catch(() => {
        this.$root.$emit('alert', 'error', '清空驗證次數失敗')
      })
    }
  }
}
</script>

<style lang="scss">
.adminTools {
  .v-input {
    max-width: 500px;
  }
}
</style>